import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
   videoDialog: {
      '& .MuiDialog-paper': {
         background: '#000',
         maxWidth: '95vw',
         width: 1200,
      },
   },
   iframeWrapper: {
      width: '100%',
      minHeight: 600,
      '& iframe': {
         width: '100%',
         height: '70vh',
         minHeight: 500,
      },
      '& video': {
         width: '100%',
      },
   },
}));

export default useStyles;